import PropTypes from 'prop-types';

import Link from 'next/link';

import clsx from 'clsx';

import { Glyphicon } from 'reaxl';

/**
 * BackLink component that renders a navigation link with a back icon and customizable text.
 * This component is used to navigate back to a previous page or section within the application.
 *
 * @param {Object} props - Component properties
 * @param {string} props.className - Additional CSS classes to apply to the link
 * @param {string} props.href - The URL to navigate to when the link is clicked
 * @param {React.ReactNode} props.children - The content to display inside the link
 * @param {Object} [props.rest] - Additional props to spread onto the link element
 * @returns {JSX.Element} A Next.js Link component that navigates to the specified href
 */
export default function BackLink({ children, className, href, ...props }) {
    return (
        <Link
            className={clsx('padding-left-0 padding-right-1 text-nowrap margin-vertical-2 btn btn-link', className)}
            href={href}
            {...props}
        >
            <Glyphicon
                glyph="menu-left"
                className="margin-right-1"
                aria-hidden="true"
            />
            {children}
        </Link>
    );
}

BackLink.propTypes = {
    /**
     * Additional CSS class name(s) to apply to the back link.
     * Will be merged with the default button styling classes.
     */
    className: PropTypes.string,
    /**
     * The URL to navigate to when the link is clicked.
     */
    href: PropTypes.string.isRequired,
    /**
     * The content to display inside the link.
     */
    children: PropTypes.node.isRequired,
};
